module.exports = __webpack_public_path__ + "img/position-station.5c812802.png";